import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useState } from "react";
import { StatusesBlock } from "./ClientCredentialsPopup";

export const S_MERCHANT_CONTROL_POPUP = new Signal<{
	merchant: IClientGroup;
	onSuccess: () => void;
	onReject?: () => void;
} | null>("S_MERCHANT_CONTROL_POPUP");

export const MerchantControlPopup = () => {
	useLocale();
	const requestData = S_MERCHANT_CONTROL_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [_error, setError] = useState<IError>();
	//const theme = useTheme() as ITheme;

	//!TODO:;
	// const statuses = ["created", "submitted", "aml_review", "rejected", "board_review", "active", "blocked", "deleted"];
	// const [selected, setSelected] = useState<string | undefined>();

	// const [reason, setReason] = useState<{ value: string }>({
	// 	value: "",
	// });

	// const [events, setEvents] = useState<any[]>([]);

	// useEffect(() => {
	// 	const loadEvents = async () => {
	// 		if (!requestData) return;
	// 		const events = await GD.REQ_API.request({
	// 			method: "events/list",
	// 			data: {
	// 				target_id: requestData.merchant.id,
	// 				target_type: "merchant_group",
	// 				action: "merchant_status_change",
	// 			},
	// 		});
	// 		if (events?.data) {
	// 			setEvents(events.data);
	// 		}
	// 	};

	// 	if (requestData) {
	// 		loadEvents();
	// 	}
	// }, [requestData]);

	// useEffect(() => {
	// 	if (requestData) {
	// 		setSelected(requestData.merchant.status);
	// 	}
	// }, [requestData]);

	if (!requestData) return <></>;

	// const handleSubmit = async () => {
	// 	setError(undefined);
	// 	if (!reason.value) {
	// 		setError({
	// 			message: "Please specify reason",
	// 			code: -1,
	// 		});
	// 	}
	// 	if (reason.value && requestData && selected) {
	// 		setBusy(true);

	// 		const res = await GD.REQ_API.request({
	// 			method: "clients/group/status/change",
	// 			data: {
	// 				group_id: requestData.merchant.id,
	// 				status: selected,
	// 				client_id: requestData.merchant.client_id,
	// 				reason: reason.value,
	// 			},
	// 		});

	// 		if (res?.error) {
	// 			setError(res?.error);
	// 		} else if (res?.data) {
	// 			requestData.onSuccess();
	// 			closePopup();
	// 		}

	// 		setBusy(false);
	// 	}
	// };

	// const onChange = async (m: IClientStatus) => {

	// 	setError(undefined);
	// 	setSelected(m);
	// };

	const closePopup = () => {
		S_MERCHANT_CONTROL_POPUP.invoke(null);
		setError(undefined);
		//setReason({ value: "" });
	};

	// const current = statuses.find(s => s === requestData.merchant.status);
	// const newStatus = statuses.find(s => s === selected);

	//!TODO: move status render to component;
	return (
		<Panel
			sx={{
				//width: "90vw",
				maxWidth: "1200px",
				padding: "0",
				minWidth: "500px",
				//width:'40vw'
			}}
			decorator="absolute"
			busy={busy}
			growContent
			label={msg("merchantControl")}
			onClose={() => {
				// if (requestData.onReject) requestData.onReject();
				closePopup();
			}}>
			<StatusesBlock setBusy={setBusy} merchant={requestData.merchant} />
			{/* <HBox>
				<VBox>
					<Spacer size="20px" />
				

					<Select
						label="Change status"
						value={selected}
						onChange={s => setSelected(s)}
						// values={statuses.map(status => ({ label: status, value: status }))}
						values={statuses.map(status => status)}
					/>

					<Spacer size="20px" />

					<VBox gap="12px">
						<Input label="Reason" data={reason} name="value" />
					</VBox>

					<Spacer size="40px" />

					<VBox sx={{ gap: "12px" }}>
						<Error error={error} />
						<Button
							title="submit"
							onClick={() => {
								handleSubmit();
							}}
						/>
					</VBox>
				</VBox>
				<VBox sx={{ backgroundColor: "#f5f5f5", width: "300px", padding: "10px" }}>
					<Typo>Status change log:</Typo>
					<VBox gap="10px" sx={{ marginTop: "10px", maxHeight: "400px", overflowY: "auto" }}>
						{events && Array.isArray(events) && events.length > 0 ? (
							events.map((event, index) => {
								return (
									<VBox key={index} sx={{ borderBottom: "1px solid #ddd", paddingBottom: "5px" }}>
										<Typo variant="caption" bold>
											{event.user_name ?? "user_" + event.user_id}
										</Typo>
										<Typo variant="caption">{event.created_at}</Typo>
									</VBox>
								);
							})
						) : (
							<Typo variant="caption">No status changes yet.</Typo>
						)}
					</VBox>
				</VBox>
			</HBox> */}
		</Panel>
	);
};
